import axios from "axios";
import { buildApiUrl } from "../config/api";

export const CA_TYPES = ["Class test", "Assignment", "Portfolio", "Rubric", "CA Test"];

export async function fetchCaAssessments(schoolId, filters = {}) {
    const params = { ...filters };
    const { data } = await axios.get(buildApiUrl(`/CaAssessments/${schoolId}`), { params });
    return Array.isArray(data) ? data : [];
}

export async function fetchClassCaSummary({ classId, term, academicYear }) {
    const params = { classId };
    if (term) params.term = term;
    if (academicYear) params.academicYear = academicYear;
    const { data } = await axios.get(buildApiUrl("/CaAssessments/summary/class"), { params });
    return data;
}

export async function createCaAssessment(payload) {
    const { data } = await axios.post(buildApiUrl("/CaAssessment"), payload);
    return data;
}

export async function updateCaAssessment(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/CaAssessment/${id}`), payload);
    return data;
}

export async function deleteCaAssessment(id) {
    const { data } = await axios.delete(buildApiUrl(`/CaAssessment/${id}`));
    return data;
}
